<script lang="ts">
  import { onDestroy } from 'svelte'
  import { get } from 'svelte/store'
  import { pageOptsStore, fn } from '@packages/stores'
  import { Error } from '@packages/ui'

  import { ERRORS, handleErrorData } from './error.helper'

  const handleCloseClick = () => get(fn).close()

  let errorData: {
    errorMessage?: string
    image?: string
    description?: string
    title?: string
    shouldRenderBackButton?: boolean
  }
  const unsub = pageOptsStore.subscribe((data) => {
    if (data.errorMessage) errorData = handleErrorData(data.errorMessage)
    else if (data.title && data.description) errorData = data
  })

  onDestroy(unsub)
</script>

<Error
  options={{
    title: errorData?.title || ERRORS.titles.DEFAULT_ERROR_TITLE,
    description: errorData?.description || ERRORS.desctiptions.DEFAULT_ERROR_DESC,
    image: errorData?.image,
    shouldRenderBackButton: errorData?.shouldRenderBackButton,
    onCloseClick: handleCloseClick,
  }}
/>
